export default "__VITE_ASSET__Br$OmRz5__"